import PropTypes from 'prop-types';
import Image from 'next/image';

// Took from intrinsic size of images
const CAROUSEL_MOBILE_IMAGE_WIDTH = 960;
const CAROUSEL_MOBILE_IMAGE_HEIGHT = 440;

export const IMAGE_INDEX_THRESHOLD_TO_LAZYLOAD = 4;

import styles from './CarouselMobile.module.scss';

const CarouselMobile = ({ onClickSlide, slides }) => slides?.length ? slides.map((image, index) => (
  <a
    key={image._id}
    href={image.urlDest}
    aria-label={image.alt}
    onClick={() => onClickSlide(image, index)}
    data-test-id="carousel-mobile-link"
  >
    {/* Defining width and height to improve CLS */}
    {index < IMAGE_INDEX_THRESHOLD_TO_LAZYLOAD ? (
      <img
        className={styles['carousel-image']}
        data-test-id="image"
        src={image.imgS}
        alt={image.alt}
        width={CAROUSEL_MOBILE_IMAGE_WIDTH}
        height={CAROUSEL_MOBILE_IMAGE_HEIGHT}
      />
    ) : (
      <div>
        <img
          className={styles['carousel-image']}
          data-test-id="lazy-load-image"
          src={image.imgS}
          alt={image.alt}
          width="100%"
          height={CAROUSEL_MOBILE_IMAGE_HEIGHT}
          loading="lazy"
        />
      </div>
    )}
  </a>
)) : null;

CarouselMobile.propTypes = {
  onClickSlide: PropTypes.func.isRequired,
  slides: PropTypes.array.isRequired
};

export default CarouselMobile;
